module.exports = {"form":{"step2":{"society_email_ex":"උදා. contact@fsf.org"}}};